import ContractMdl from '@/models/HumanResource/HrContract'
import contractIncludes from '../contract/contractIncludes'
export default async () => {
    //
    try {
        //
        let response = await ContractMdl.include(...contractIncludes).get()
        return response
    } catch (error) {
        //
        return error.response.data
    }
}
